import React, { lazy, useEffect, useState } from "react";
import * as jose from "jose";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePages from "./pages/home";
import MembersPage from "./pages/members";
import ProfilePage from "./pages/profile";
import LoginPage from "./pages/login";
import SignInPage from "./pages/register";
import PricingPlanPage from "./pages/pricingplan";
import ForeZeroPage from "./pages/forezero";
import CommunityPage from "./pages/community";
import BlogPage from "./pages/blog";
import BlogSinglePage from "./pages/blogsingle";
import ContactPage from "./pages/contact";
import ScrollToTop from "./component/layout/scralltop";
import ForgotPasswordPage from "./pages/forgotPassword";
//import ResetPasswordPage from "./pages/resetPassword";
import ResetPasswordPage from "./pages/resetPasswordPage";
import ProfileList from "./pages/profileList";
import EditProfile from "./pages/editProfile";
import ProfileFilter from "./pages/profileFilter";
import { setAuth } from "./redux/features/authSlice";
import { useDispatch } from "react-redux";
import PaymentDone from "./pages/paymentDone";
import PaymentDoneEmail from "./pages/paymentDoneEmail";
import VolunteerLogin from "./pages/volunteerLogin";
import ProfileShortlist from "./pages/profileShortlist";
import AdminLoginPage from "./pages/adminLogin";
import Subscription from "./pages/subscription";
import AdminDashboard from "./pages/adminDashboard";
import DashboardHeader from "./component/section/DashboardHeader";
import DashboardContainer from "./component/layout/DashboardContainer";
import Register from "./pages/register";
import CreateVolunteer from "./pages/createVolunteer";
import { jwtDecode } from "jwt-decode";
import ViewProfile from "./pages/viewProfile";
import ProfileDashboard from "./pages/profileDashboard";
import PaymentLinkPage from "./pages/paymentLinkPage";
import PaymentPage from "./pages/payment";
import { clearLocalStorage } from "./utils/utility";
import ViewVolunteer from "./pages/viewVolunteer";
import ViewAccount from "./pages/viewAccount";
import StripeSubscription from "./component/payment/StripeSubscription";
import LoaderComponent from "./component/loader/LoaderComponent";
import JoinBAT from "./pages/joinBAT";
import SubscriptionDataList from "./pages/subscriptionDataList";
import AccountsToBeVerified from "./pages/accountsToBeVerified";
import UpgradeToBat from "./pages/upgradeToBat";
import ViewBatAccount from "./pages/viewBatAccount";
import BatHome from "./pages/batHome";
import BatEvents from "./pages/batEvents";
import Confirmation from "./pages/mailConfirmation";
import MyAccount from "./pages/myAccount";

const Header = lazy(() => import("./component/layout/header"));
const FooterSection = lazy(() => import("./component/layout/footer"));

const App = () => {
  const disPatch = useDispatch();
  const [isMainFooter, setIsMainFooter] = useState(true);

  useEffect(() => {
    const fetchedJwtToken = localStorage.getItem("jwtToken");
    if (fetchedJwtToken) {
      const jwtToken = JSON.stringify(fetchedJwtToken?.split(" ")[1]);
      const decodedToken = jwtDecode(jwtToken);
      const currentTime = Date.now() / 1000;
      if (decodedToken?.exp < currentTime) {
        clearLocalStorage();
      } else {
        dispatchData(decodedToken);
      }
    }
  }, []);

  function dispatchData(decoded) {
    disPatch(setAuth(decoded));
  }

  return (
    <React.Suspense fallback={<LoaderComponent />}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={<Header setIsMainFooter={setIsMainFooter} />}>
            <Route index element={<BatHome />} />
            <Route path="bat-matrimony" element={<HomePages />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<Register />} />
            <Route path="join-bat" element={<JoinBAT />} />
            <Route path="forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/bat/reset-password" element={<ResetPasswordPage />} />
            <Route path="blog-single" element={<BlogSinglePage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="members" element={<MembersPage />} />
            <Route path="payment" element={<PaymentLinkPage />} />
            <Route path="payment-page" element={<PaymentPage />} />
            <Route path="contact-us" element={<ContactPage />} />
            <Route path="payment-done" element={<PaymentDoneEmail />} />
            <Route path="bat-events" element={<BatEvents />} />
            <Route path="confirmation" element={<Confirmation />} />
          </Route>
          <Route
            path="/dashboard"
            element={<DashboardContainer setIsMainFooter={setIsMainFooter} />}>
            <Route index element={<ProfileDashboard />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="account" element={<MyAccount />} />
            <Route path="profile-list" element={<ProfileList />} />
            <Route path="profile-shortlist" element={<ProfileShortlist />} />
            <Route path="profile-filter" element={<ProfileFilter />} />
            <Route path="edit-profile/:id" element={<EditProfile />} />
            <Route path="view-profile/:id" element={<ViewProfile />} />
            <Route path="upgrade-to-bat" element={<UpgradeToBat />} />
            <Route path="upgrade-account" element={<PaymentPage />} />
            <Route path="payment-done" element={<PaymentDone />} />
          </Route>
          <Route
            path="/volunteer"
            element={<DashboardContainer setIsMainFooter={setIsMainFooter} />}>
            <Route index element={<AccountsToBeVerified isBatAccounts={true} isUnVerified={true} />} />
            <Route path="profile-list" element={<ProfileList />} />
            <Route path="profile-shortlist" element={<ProfileShortlist />} />
            <Route path="profile-filter" element={<ProfileFilter />} />
            <Route
              path="matrimony-accounts"
              element={<AccountsToBeVerified isMatrimonyAccounts={true} />}
            />
            <Route path="view-account/:id" element={<ViewAccount />} />
            <Route path="view-profile/:id" element={<ViewProfile />} />
            <Route
              path="bat-accounts"
              element={<AccountsToBeVerified isBatAccounts={true} />}
            />
            <Route path="view-bat-account/:id" element={<ViewBatAccount />} />
          </Route>
          <Route
            path="/admin"
            element={<DashboardContainer setIsMainFooter={setIsMainFooter} />}>
            <Route index element={<AccountsToBeVerified isBatAccounts={true} isUnVerified={true} />} />
            <Route path="profile-list" element={<ProfileList />} />
            <Route path="view-profile/:id" element={<ViewProfile />} />
            <Route path="view-volunteer:id" element={<ViewProfile />} />
            <Route path="volunteer-list" element={<AdminDashboard />} />
            <Route path="view-volunteer/:id" element={<ViewVolunteer />} />
            <Route path="profile-list" element={<ProfileList />} />
            <Route
              path="matrimony-accounts"
              element={<AccountsToBeVerified isMatrimonyAccounts={true} />}
            />
            <Route path="view-account/:id" element={<ViewAccount />} />
            <Route path="profile-filter" element={<ProfileFilter />} />
            <Route
              path="subscription-details"
              element={<SubscriptionDataList />}
            />
            <Route
              path="bat-accounts"
              element={<AccountsToBeVerified isBatAccounts={true} />}
            />
            <Route path="view-bat-account/:id" element={<ViewBatAccount />} />
          </Route>
          <Route path="/bat" element={<Header setIsMainFooter={setIsMainFooter} />}>
            <Route index element={<HomePages />} />
            <Route path="payment" element={<PaymentLinkPage />} />
            <Route path="payment-page" element={<PaymentPage />} />
          </Route>
          <Route path="*" element={<ForeZeroPage />} />
        </Routes>
        {isMainFooter && <FooterSection />}
      </BrowserRouter>
    </React.Suspense>
  );
};

export default App;
